import { useEffect, useState } from "react";
import { getPermissionsApi, getDesignationPermissionsApi, updateDesignationPermissionsApi, getUserOverridesApi, updateUserOverridesApi, getEffectivePermissionsApi, getPermissionByIdApi, createPermissionApi, updatePermissionApi, deletePermissionApi, } from "../apiServices/permission.services";

const usePermissions = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPermissions = async (params = {}) => {
    try {
      setLoading(true);
      const res = await getPermissionsApi(params);
      setPermissions(res?.data || []);
      return res?.data || [];
    } catch (error) {
      console.error(error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  // =======================
  // Permission CRUD
  // =======================

  const fetchPermissionById = async (id) => {
    const res = await getPermissionByIdApi(id);
    return res?.data || {};
  };

  const createPermission = async (body) => {
    return await createPermissionApi(body);
  };

  const updatePermission = async (id, body) => {
    return await updatePermissionApi(id, body);
  };

  const deletePermission = async (id) => {
    return await deletePermissionApi(id);
  };

  // =======================
  // Designation Permissions
  // =======================

  const fetchDesignationPermissions = async (designationId) => {
    const res = await getDesignationPermissionsApi(designationId);
    return res?.data || [];
  };

  const updateDesignationPermissions = async ( designationId, permissions ) => {
    return await updateDesignationPermissionsApi(designationId, { permissions, });
  };

  // =======================
  // User Overrides
  // =======================

  const fetchUserOverrides = async (userId) => {
    const res = await getUserOverridesApi(userId);
    return res?.data || {};
  };

  const updateUserOverrides = async ( userId, allow = [], deny = [] ) => {
    return await updateUserOverridesApi(userId, { allow, deny, });
  };

  // =======================
  // Effective Permissions
  // =======================

  const fetchEffectivePermissions = async (userId) => {
    const res = await getEffectivePermissionsApi(userId);
    return res?.data || [];
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  return { permissions, loading, fetchPermissions, fetchPermissionById, createPermission, updatePermission, deletePermission, fetchDesignationPermissions, updateDesignationPermissions, fetchUserOverrides, updateUserOverrides, fetchEffectivePermissions, };
};

export default usePermissions;